import { useTranslation } from "react-i18next";
import "../../i18n";
import { Combobox } from "../../design/components";
import { useEntities } from "../../api/queries";
import type { StageCounts } from "../../api/types";
import { FilterControls } from "./FilterControls";
import type { QueueFilters as BaseFilters } from "./queueFilterState";

export type QueueFilterState = BaseFilters & { entityId: string };

/** The console queue's filters: the shared controls plus the company picker. */
export function QueueFilters({
  filters,
  onChange,
  onClear,
  hasFilters,
  stageCounts,
}: {
  filters: QueueFilterState;
  onChange: (patch: Partial<QueueFilterState>) => void;
  onClear: () => void;
  hasFilters: boolean;
  stageCounts?: StageCounts | undefined;
}) {
  const { t } = useTranslation();
  const entities = useEntities();
  const allCompanies = t("documents.filters.allCompanies", "All companies");
  const options = [
    { v: "", n: allCompanies },
    ...(entities.data ?? []).map((entity) => ({ v: entity.id, n: entity.legalName, d: entity.code })),
  ];

  return (
    <FilterControls
      filters={filters}
      onChange={onChange}
      onClear={onClear}
      hasFilters={hasFilters}
      stageCounts={stageCounts}
      company={
        <Combobox
          id="queue-company"
          value={filters.entityId}
          options={options}
          placeholder={allCompanies}
          onPick={(value) => onChange({ entityId: value })}
        />
      }
    />
  );
}
